import React from "react";
import { motion } from "framer-motion";

// Signature line-by-line masked reveal. trigger="load" plays on mount,
// trigger="inView" plays when scrolled into view.
export const MaskText = ({
  lines = [],
  className = "",
  lineClassName = "",
  accentIndex = -1,
  accentClassName = "",
  delay = 0,
  stagger = 0.11,
  duration = 0.9,
  trigger = "inView",
}) => {
  const anim = { y: 0 };
  const motionProps =
    trigger === "load"
      ? { initial: { y: "118%" }, animate: anim }
      : { initial: { y: "118%" }, whileInView: anim, viewport: { once: true, amount: 0.4 } };

  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span
            {...motionProps}
            transition={{ duration, ease: [0.22, 1, 0.36, 1], delay: delay + i * stagger }}
            className={`block ${lineClassName} ${i === accentIndex ? accentClassName : ""}`}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};
